export const ENDPOINT = {
  hourly: '/hourly',
  daily: '/daily',
  weekly: '/weekly',
  et0: '/daily',
};

export const WEATHER_SENSOR_TYPES = [
  'Temperature',
  'Humidity',
  'Wind Direction',
  'Rain',
  'Solar Radiation',
  'Wind Velocity',
  'Wind Speed',
  'Atmospheric Pressure',
];

export const HIGHCHARTS_ROUTES_MAP: { [key: string]: string } = {
  'Humedad Suelo': 'humedad-suelo',
  'Humedad Suelo Apilado': 'humedad-suelo-apilada',
  Riego: 'riego',
  Kc: 'kc',
  ET0: 'et0',
  Precipitaciones: 'precipitaciones',
  'Profundidad de Riego': 'profundidad-riego',
  'Dendrometro de brote': 'planta',
};

export const CHART_LIST_UI = [
  {
    label: 'Fecha Actualización', key: 'updatedAt',
  },
  {
    label: 'Actualizado por', key: 'updatedBy',
  },
  {
    label: 'Último comentario', key: 'lastComment',
  },
  {
    label: 'Campo', key: 'farm',
  },
  {
    label: 'Sector', key: 'sector',
  },
  {
    label: 'Gráfico', key: 'chart',
  },
  {
    label: 'Ver Conversación', key: 'viewConversation',
  },
];

export const RULER_LINES = [
  { id: 'ruler-line-1', label: 'Regla 1', color: '#0EA5E9' },
  { id: 'ruler-line-2', label: 'Regla 2', color: '#F59E0B' },
];

export const RULER_LINE_WIDTH = 2;
export const RULER_LINE_Z_INDEX = 5;
export const RULER_LINE_DASH_STYLE = 'ShortDash';
export const RULER_LABEL_OFFSET = { x: 4, y: 8 };
export const RULER_DATE_FORMAT = 'DD/MM HH:mm';
export const RULER_BADGE_MIN_WIDTH = { single: 110, compared: 150 };
export const RULER_DELTA_COLOR = {
  positive: '#86EFAC',
  negative: '#FECACA',
  neutral: 'rgba(255,255,255,0.6)',
};
export const RULER_EXCLUDED_SERIES_TYPES = ['arearange', 'scatter'];

export const CONVERSATION_UI_LIST = [
  {
    label: 'Fecha actualización', key: 'updatedAt',
  },
  {
    label: 'Actualizado por', key: 'updatedBy',
  },
  {
    label: 'Último comentario', key: 'lastComment',
  },
  {
    label: 'Campo', key: 'farmName',
  },
  {
    label: 'Sector', key: 'sectorName',
  },
  {
    label: 'Gráfico', key: 'chart',
  },
  {
    label: 'Acciones', key: 'seeMore',
  },
];
